"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MontBesList = void 0;
const ArticleList_1 = require("../ArticleList");
const ArticleUtils_1 = require("../ArticleUtils");
const MontBes_1 = require("./MontBes");
/**
 * The `MontBesList` manages a list of `MontBes` articles.
 */
class MontBesList extends ArticleList_1.ArticleList {
    constructor() {
        super();
    }
    static fromScratch() {
        return new MontBesList();
    }
    static fromJson(json, cloneStrategy = 'deep') {
        const list = new MontBesList();
        list.fromJson(json, cloneStrategy);
        return list;
    }
    static fromModel(model) {
        const list = new MontBesList();
        list.fromModel(model);
        return list;
    }
    static fromArray(arr) {
        const list = new MontBesList();
        list.fromArray(arr);
        return list;
    }
    fromJson(json, cloneStrategy = 'deep') {
        this.items = [];
        for (const itemJson of json) {
            this.items.push(MontBes_1.MontBes.fromJson(itemJson, cloneStrategy));
        }
        this.model = this.items.map((i) => i.toModel());
        this.emitChange();
    }
    fromModel(model) {
        this.items = model.map((m) => MontBes_1.MontBes.fromModel(m));
        this.model = model;
        this.emitChange();
    }
    toJson() {
        return this.items.map((i) => i.toJson());
    }
    toModel() {
        return this.model;
    }
    clone() {
        return MontBesList.fromArray(this.items.map((i) => i.clone()));
    }
    group(options) {
        return ArticleUtils_1.ArticleUtils.groupArticles(this.items, options);
    }
}
exports.MontBesList = MontBesList;
//# sourceMappingURL=MontBesList.js.map